import Textarea from 'components/textarea/Textarea';
import styled from 'styled-components';

export const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const TextareaStyled = styled(Textarea)`
  min-height: 170px;
`;
